import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { BlueprintDeploymentStack } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";

const TemplateDeploymentStacksNameCell = ({
  item: stack,
  ...cellProps
}: TableSimpleCellProps<BlueprintDeploymentStack>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLink href={`/stack/${stack.id}`}>{stack.name}</TableCellLink>
    </TableSimpleCell>
  );
};

export default TemplateDeploymentStacksNameCell;
